import {
  locForGetClientConfig,
  locForSetClientConfig,
} from "@/models/localForage/localForage.model";
import {
  ThemeContext,
  ThemeContextType,
} from "@/services/ThemeContext/ThemeContext";
import { setGlobalColorTheme } from "@/shadcn/lib/ThemeColors/theme-colors";
import React, { ReactNode, useEffect, useState } from "react";

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [displayName, setDisplayName] = useState<string>("");
  const [logo, setLogo] = useState<string>("");
  const [customLoaderImage, setCustomLoaderImage] = useState<string>("");

  useEffect(() => {
    // Load the theme from localForage on mount
    const loadTheme = async () => {
      const clientConfig = await locForGetClientConfig();
      if (clientConfig) {
        setDisplayName(clientConfig.displayName);
        setLogo(clientConfig.logo);
        setCustomLoaderImage(clientConfig.customLoaderImage);
        document.title = clientConfig.displayName;
        setGlobalColorTheme(clientConfig.cssVariables);
      }
    };
    loadTheme();

    return () => {
      // clean up
      setDisplayName("");
      setLogo("");
      setCustomLoaderImage("");
      document.title = "Loading...";
      setGlobalColorTheme({});
    };
  }, []);

  const setTheme = async (config: Partial<ThemeContextType>) => {
    if (config.displayName) setDisplayName(config.displayName);
    if (config.logo) setLogo(config.logo);
    if (config.customLoaderImage)
      setCustomLoaderImage(config.customLoaderImage);

    // Persist the changes to localForage
    const clientConfig = await locForGetClientConfig();
    if (clientConfig) {
      const updatedConfig = {
        ...clientConfig,
        ...config,
      };
      await locForSetClientConfig(updatedConfig);
    }
  };

  return (
    <ThemeContext.Provider
      value={{ displayName, logo, customLoaderImage, setTheme }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
